import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import useAuth from "../../hooks/useAuth";
import { useLoginGate } from "../../context/login-gate";

//前台登入守門（只處理「直接貼網址進來」的情況）
//
//  一般操作路徑（點底部頁籤、漢堡）已經在按下去的當下就攔截了，
//  未登入不會導頁、直接在原地跳彈窗（見 context/login-gate）。
//
//  但使用者仍可能直接貼網址或用書籤進到受保護的頁面。此時：
//    先導回首頁，再由登入閘門在首頁上跳彈窗、記住原本要去的位置。
//  這樣彈窗背景是首頁而不是一片空白 —— 使用者知道自己只是被擋了一下，
//  登入完成後也會被帶到原本想去的地方。
//
//  props:
//    to       登入後要前往的路徑
//    message  彈窗上的情境說明
const RequireUserAuth = ({ children, to, message }) => {
  const { isLoggedIn } = useAuth();
  const { requireLogin } = useLoginGate();

  //未登入時觸發登入閘門
  //  放在 effect 而不是渲染中：渲染期間改別的元件的 state 會被 React 警告
  useEffect(() => {
    if (!isLoggedIn) requireLogin(to, message);
  }, [isLoggedIn, requireLogin, to, message]);

  if (isLoggedIn) return children;

  //導回首頁，讓彈窗有背景可襯
  return <Navigate to="/" replace />;
};

export default RequireUserAuth;
